import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { Resolution } from './types'

export function useGetGroundTruth(id?: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['groundTruthResolutions', id],
    queryFn: async () => {
      const { data } = await apiClient.get<Resolution[]>('int/resolution', {
        params: { engagement_id: id, ground_truth: true },
      })
      return data
    },
    enabled: Boolean(id) && (options?.enabled ?? true),
  })
}
